import React, { Component } from 'react';
import './App.css';
import GridItem from './GridItem.js';
import MenuItem from './MenuItem.js';
import MessageBannerItem from './MessageBannerItem.js';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import html2canvas from 'html2canvas';
import ShareLinkItem from './ShareLinkItem.js';
import SearchItem from './SearchItem.js';
import FunctionQueue from './FunctionQueue.js'
import Spinner from 'react-bootstrap/Spinner'
import { getParameterLid } from './utils/utils';

class App extends Component {

  constructor(props) {
    super(props);
    let serviceUrl = process.env.REACT_APP_VMT_API;
    //prod / local brutal switch for https mixed content stuff
    this.baseServiceUrl = serviceUrl + 'vmtapi';//(serviceUrl.includes("qa8.edge.regiongold.com") ? 'https://'+serviceUrl : 'http://localhost:9000' ) + '/vmtapi';
    this.baseServiceUrlFiles = serviceUrl + 'vmtfiles';//(serviceUrl.includes("qa8.edge.regiongold.com") ? 'https://'+serviceUrl : 'http://localhost:9000' ) + '/vmtapi';
    this.state = {
      products: [],
      viewMobile: false,
      missingImages: false,
      selectedFile: null,
      loaded: 0,
      fileUploadResult: '',
      fileGenerated: false,
      fileGeneratedName: '',
      fileGeneratedForHybris: false,
      fileGeneratedNameForHybris: '',
      showShare: false,
      mailRecipients: '',
      projectTitle: 'Visual Merchandize Tool',
      sharingContent: false,
      sendMailError: false,
      sendMailErrorMessage: '',
      messages: [this.getMessage('MSG', 'Welcome to VMT - GI', 'Welcome', 'Short')],
      searchTitle: '',
      searchShouldShow: false,
      searchLabel: '',
      searchFormat: '',
      searchSuggestions: [],
      heroImageUrl: '',
      isSpinnig: false,
      isIsEnabled: true,
    };
    this.sendMail = this.sendMail.bind(this);
  }

  getMessage(msgType, message, title, shouldHide) {
    return {
      mpk: this.generateUUID(),
      type: msgType, //[ERR|WARN|MSG]
      msg: message,
      title: title,
      hide: shouldHide,  //[Short|Medium|Long|Immortal]
    }
  }

  getIsDomain() {
    return this.state.isIsEnabled ? 'media.gucci.com' : 'imgdev.edge.regiongold.com';
  }

  getImages(product, resolveclbck) {

    var pid = {
      style: product.code.substring(0, 6),
      material: product.code.substring(6, 11),
      color: product.code.substring(11, 15)
    }

    let isDomain = this.getIsDomain();

    var apiUrl = "https://" + isDomain + "/api/v2/images?q[idref_eq]=" + pid.style + "_" + pid.material + "_" + pid.color + "&q[format_eq]=DarkGray_South_0_160_316x316&q[position_eq]=001";

    FunctionQueue.enqueue(apiUrl,
      (data) => {
        this.manageImageData(data, product);
        if (resolveclbck) resolveclbck(product);
      },
      resolveclbck,
      () => { product.isErrorImg = true; }
    );

  }

  manageImageData(data, product) {
    var placeholder = '';
    var imgUrl = placeholder;
    var isErrorImg = false;

    if (data != null && data[0] != null)
      imgUrl = data[0].url;
    else {
      //todo refactor
      let ppid = {
        style: product.code.substring(0, 6),
        material: product.code.substring(6, 11),
        color: product.code.substring(11, 15)
      }
      imgUrl = `https://getimage.emea.guccigroup.dom/getimage/?Cod=${ppid.style}-${ppid.material}-${ppid.color}`
      isErrorImg = true;
    }

    product.imgUrl = imgUrl;
    product.isErrorImg = isErrorImg;
  }

  findDuplicates(prodArr) {
    return prodArr.filter((itm, idx) => prodArr.findIndex((item, idxx) => itm.code === item.code) !== idx);
  }

  removeDuplicates(prodArr) {
    return prodArr.filter((itm, idx) => prodArr.findIndex((item, idxx) => itm.code === item.code) === idx)
  }

  manageData(res) {
    //remove duplicates if any
    let sProducts = this.removeDuplicates(res.data.prods);
    let doubleCodes = this.findDuplicates(res.data.prods);

    const promiseArray = sProducts.map(
      (item) => {
        return new Promise((resolve, reject) => {
          item.isOver = false;
          item.isErrorImg = false;
          item.isSelected = false;
          item.isEditing = false;

          //always force retrieve of images from IS so that you can see updated images if any compared to when the
          //merchandise was performed
          item.imgUrl = '';

          if (item.imgUrl === '' || item.imgUrl === undefined) {
            this.getImages(item, resolve);

          } else {
            resolve();
          }
        });
      }
    );

    this.setState({ isSpinnig: true });

    //same story: update one by one once ready (stressing state) or wait synch for all (freezing ui)?
    Promise.all(promiseArray).then(() => {
      let msgFileUpload = this.getMessage(res.data.resType, res.data.resMessage, 'File uploaded', (res.data.resType === 'ERR' ? 'Immortal' : 'Medium'));
      let msgDuplicates = [];
      if (doubleCodes.length > 0) {
        msgDuplicates = this.getMessage('WARN', 'The following stylecodes were duplicated and removed:' + doubleCodes.map((itm) => { return itm.code; }).join('-'), 'Not unique stylecodes', 'Long');
      }
      this.setState({
        isSpinnig: false,
        products: sProducts,
        messages: [...this.state.messages, msgFileUpload, msgDuplicates],
        fileGenerated: false,
        fileGeneratedName: '',
        fileGeneratedForHybris: false,
        fileGeneratedNameForHybris: '',
        viewMobile: (res.data.mobileView !== undefined && res.data.mobileView === 'true') ? true : false,
        projectTitle: res.data.projectTitle != null ? res.data.projectTitle : 'Visual Merchandize Tool',
        heroImageUrl: res.data.heroImage,
      })
    })

  }

  handleCloseMessage(messagePk) {
    let goodMessages = this.state.messages.filter(message => message.mpk !== messagePk);
    this.setState({ messages: goodMessages });
  }

  handleDeleteSelectedProduct() {
    let goodProducts = this.state.products.filter(item => !item.isSelected);
    this.setState({ products: goodProducts })
    this.resetFileGen();
  }

  handleDeleteProduct(styleCode) {
    let sCodes = styleCode.split('\n');
    let goodProducts = this.state.products.filter(item => sCodes.find(itm => itm === item.code) === undefined);

    this.setState({ products: goodProducts })
    this.resetFileGen();
  }

  handleHideProduct(product) {
    this.setState(state => {
      // eslint-disable-next-line
      const list = state.products.map((itm) => {
        if (itm.pk === product.pk) {
          itm.isHidden = !itm.isHidden;
        }
      });
      return list;
    })
  }

  handleCopy() {
    var data = this.state.products;
    if (this.state.missingImages) {
      data = this.state.products.filter((itm) => { return itm.isErrorImg; });
    }
    data = data.filter((itm) => { return itm.isSelected; });

    var dataS = data.length > 0 ? data.map(itm => itm.code).join('\n') : 'No product selected';
    copy(dataS, { format: 'text/plain' })
  }

  handleselectedFile(e) {
    if (e.target.files[0]) {
      this.setState({
        selectedFile: e.target.files[0],
        loaded: 0
      },
        this.handleFileUpload
      )
    }
  }

  handleFileUpload() {
    const data = new FormData()
    data.append('prodFile', this.state.selectedFile, this.state.selectedFile.name)
    axios
      .post(this.baseServiceUrl + '/upload', data, {
        onUploadProgress: ProgressEvent => {
          this.setState({
            loaded: (ProgressEvent.loaded / ProgressEvent.total * 100),
          })
        },
      })
      .then(res => {
        this.manageData(res)
      })
  }

  handleDrop(e, product) {

    var codeToinsert = e.dataTransfer.getData('text');
    var insertBeforeCode = product.pk;
    //positioning in array
    var idxToInsert = this.state.products.findIndex((itm) => { return itm.pk === codeToinsert });
    var idxInsertAt = this.state.products.findIndex((itm) => { return itm.pk === insertBeforeCode });

    if (idxToInsert < idxInsertAt) idxInsertAt -= 1;
    //items to handle
    var itmInsertAt = this.state.products.find((itm) => { return itm.pk === insertBeforeCode });
    //var itmToInsert = this.state.products.find((itm)=>{return itm.pk === codeToinsert});
    //insert items properly
    this.setState(state => {
      const list = state.products.splice(idxInsertAt, 0, state.products.splice(idxToInsert, 1)[0]);
      itmInsertAt.isOver = false;
      return {
        list
      };
    },
      () => {//fillgaps AFTER insert is applied
        var normalizedResult = this.normalizePromos(true, this.state.products);
        if (normalizedResult.didChange) {
          this.setState({ products: normalizedResult.normArr });
        }
      });

    this.setState({
      fileGenerated: false,
      fileGeneratedName: '',
      fileGeneratedForHybris: false,
      fileGeneratedNameForHybris: '',
    });
  }

  handleDragOver(e, item) {
    if (!item.isOver) {
      this.setState(state => {
        // eslint-disable-next-line
        const list = state.products.map((itm) => {
          if (itm.pk === item.pk) { itm.isOver = true; }
          else itm.isOver = false;
        });
        return {
          list,
        };
      });
    }
    e.preventDefault();
  }

  handleMissingImagesViewClick() {
    this.setState({ missingImages: !this.state.missingImages })
  }

  postData(fullFormat) {
    if (this.state.products.length > 0) {
      let data = {
        // eslint-disable-next-line
        products: this.state.products.map((itm, idx) => {
          if (!itm.isHidden && !itm.isPromo) return itm
        }), full: fullFormat
      };

      axios.post(this.baseServiceUrl + '/download', data)
        .then(response => {
          let fName = this.baseServiceUrlFiles + '/generated/' + response.data.filename;
          if (fullFormat) {
            this.setState({
              fileGenerated: false,
              fileGeneratedName: fName,
            });

          } else {
            this.setState({
              fileGeneratedForHybris: false,
              fileGeneratedNameForHybris: fName,
            });
          }
          window.open(fName, "_self");
        })
        .catch(error => console.log(error));
    }
  }

  handleFullDownloadClick() {
    this.postData(true);
  }

  handleDownloadForHybrisClick() {
    this.postData(false)
  }

  //VODOOOOOOOO!
  //it would be better to place it server side .....
  generateUUID(seed) { // Public Domain/MIT

    let d = 0;
    if (seed == null) d = new Date().getTime();
    else d = seed * Math.random();


    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      // eslint-disable-next-line
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  insertItemInProducts(product, productCode, description, isPromo) {

    let idxInsertAt = 0;
    if (product != null) {
      idxInsertAt = this.state.products.findIndex((itm) => { return itm.pk === product.pk });

      //promo components stay left or right, not in the middle
      if (isPromo)
        idxInsertAt = idxInsertAt % 2 === 0 ? idxInsertAt : idxInsertAt + 1;
    }
    //productCode could be a list of products. \n separated
    //spread and Set to unique codes only
    let allNewProdCodes = [...new Set(productCode.split('\n'))];//productCode.split('\n');

    /*REMOVE duplicates from prodCodes*/
    //unique new values not already inserted
    let prodCodes = allNewProdCodes.filter((newProd) => { return !this.state.products.some((existingItem) => { return existingItem.code === newProd }) });
    //not unique new items already present
    let duplicates = allNewProdCodes.filter((newProd) => { return this.state.products.some((existingItem) => { return existingItem.code === newProd }) });
    //notify duplicates if any
    if (duplicates.length > 0) {
      var msgDuplicates = this.getMessage('WARN', 'The following stylecodes were duplicated and not added: ' + duplicates.join(', '), 'Not unique stylecodes', 'Long');
      this.setState({
        messages: [...this.state.messages, msgDuplicates],
      });
    }
    //in case map get called more than once per millisec, for pks
    let seed = prodCodes.length > 1 ? 1000 : null;

    var prodsToInsert = prodCodes.map((item) => {
      var newProd = {
        code: item,
        department: "",
        depnum: "",
        description: isPromo ? description : item,
        function: "",
        imgUrl: "",
        isErrorImg: isPromo ? true : false,
        isOver: false,
        isPromo: isPromo,
        line: "",
        isHidden: false,
        pk: this.generateUUID(seed),
      }

      return newProd;
    });

    if (prodsToInsert.length > 0) {
      const promiseArray = prodsToInsert.map(
        (item) => {
          return new Promise((resolve, reject) => {
            if (!isPromo) this.getImages(item, resolve);
            else resolve();
          });
        }
      );
      this.setState({ isSpinnig: true });
      Promise.all(promiseArray).then(() => {
        let newParr = this.state.products.slice(0);
        newParr.splice(idxInsertAt, 0, ...prodsToInsert);

        var normalizedResult = this.normalizePromos(true, newParr);
        if (normalizedResult.didChange) {
          this.setState({ products: normalizedResult.normArr, isSpinnig: false });
        } else this.setState({ products: newParr, isSpinnig: false })

      });
      this.resetFileGen();
    }
  }

  resetFileGen() {
    this.setState({
      fileGenerated: false,
      fileGeneratedName: '',
      fileGeneratedForHybris: false,
      fileGeneratedNameForHybris: '',
    });
  }

  handleAddProductClick(product, styleCode) {
    this.insertItemInProducts(product, styleCode, styleCode, false);
    this.resetFileGen();
  }

  handleAddPromoClickClick(product) {
    this.insertItemInProducts(product, "promo" + this.generateUUID(), "PROMO COMPONENT", true);
  }

  handleSwitchViewClick() {
    this.setState({ viewMobile: !this.state.viewMobile })
  }

  handleShareClick() {
    this.setState({ showShare: true });
  }

  sendMail(imgData, endFunc) {
    let data = new FormData()
    data.append('image', imgData);
    data.append('to', this.state.mailRecipients);
    data.append('title', this.state.projectTitle);
    data.append('message', this.state.mailMessage);
    data.append('products', JSON.stringify(this.state.products));
    data.append('baseUrl', window.location.href);
    data.append('mobileView', this.state.viewMobile)
    data.append('heroImage', this.state.heroImageUrl)

    let config = {
      header: {
        'Content-Type': 'multipart/form-data'
      }
    }

    axios.post(this.baseServiceUrl + '/share', data, config)
      .then(res => {
        this.setState({ messages: [...this.state.messages, this.getMessage(res.data.resType, res.data.resMessage, 'Share content', (res.data.resType === 'ERR' ? 'Immortal' : 'Medium'))], });
      })
      .catch(err => {
        console.log(err.response);
      });
  }

  canvasReady(canvas, sendMailFunc, endFunc) {
    canvas.toBlob((blob) => { sendMailFunc(blob) }
      , 'image/jpeg', 0.95)
  }

  //share behaviour
  handleShareSubmit(data) {
    this.setState({
      mailRecipients: data.email,
      mailMessage: data.emailMessage,
      sharingContent: true,
    }, () => {

      html2canvas(document.querySelector("#grid"),
        {
          logging: true,
          proxy: this.baseServiceUrlFiles + '/image',
          scale: 0.7,
        })
        .then((canvas) => { this.canvasReady(canvas, this.sendMail) })
        .then(() => { this.handleCloseShare() });
    });
  }

  handleCloseShare() {
    this.setState({ showShare: false, sharingContent: false, });
  }

  normalizePromos(switchWithNext, productsArray) {
    let retRes = { didChange: false, normArr: [] };
    if (!(productsArray.length > 0)) {
      console.log('No products');
      return retRes;
    }
    /*
    dragging and dropping items can lead to a status where a promos can generate holes.
    This can happen when a promo sits in an odd position, index 0 based.
    so, whenever a promo sits in 1,3,5,... it should be switched with previous or next item, 
    depending on switchWithNext parameter.

    BUT, despite of beeing in an even position it must be taken into algorithm the fact
    that a promo fills TWO slots, so the current 'VISUAL' position is
    #(previous items) + 2(previuos promos) not the real position in the array

    */
    let vIdx = 0;
    let lastPk = 0
    productsArray.forEach(item => { //scan
      if (item.isPromo && lastPk !== item.pk) { //a promo not previously seen?
        if ((vIdx % 2) === 1) { //odd position
          //find idxs to switch
          let idxPromo = productsArray.findIndex((itm) => { return itm.pk === item.pk });
          let idxSwitch = switchWithNext ? idxPromo++ : idxPromo--;
          //switch
          //check for array boundaries
          if (idxSwitch < productsArray.length - 1 && idxSwitch > -1) {
            let tItem = productsArray[idxPromo];
            productsArray[idxPromo] = productsArray[idxSwitch];
            productsArray[idxSwitch] = tItem;
            //we changed something
            retRes.didChange = true;
          }
        }
        lastPk = item.pk;
        vIdx += 2;
      } else {
        vIdx++;
      }
    });

    retRes.normArr = productsArray;
    return retRes;
  }

  componentDidMount() {

    let lid = getParameterLid();

    if (lid !== null) {
      //page invoked via share
      this.setState(
        {
          sharingContent: true
        }, () => {
          axios.get(this.baseServiceUrl + '/share/' + lid)
            .then(res => {
              this.manageData(res)
            })
        });
    }
  }

  handleEditClick() {
    this.setState({ sharingContent: false })
  }

  handleProductClick(product) {
    if (!this.state.sharingContent) {
      this.setState(state => {
        // eslint-disable-next-line
        const list = state.products.map((itm) => {
          if (itm.pk === product.pk) {
            //console.log(product.code);
            itm.isSelected = !itm.isSelected;
          }
        });
        return list;
      })
    }
  }

  handleSelection(action) {
    var checked = action === 'All';
    this.setState(state => {
      // eslint-disable-next-line
      const list = state.products.map((itm) => {
        itm.isSelected = checked;
      });
      return list;
    })
  }

  handleTemplateClick() {
    window.open(this.baseServiceUrlFiles + '/template', "_self");
  }

  handleTitleChange(title) {
    this.setState({
      projectTitle: title,
    });
  }

  handlePreview() {
    this.setState({
      sharingContent: !this.state.sharingContent
    });
  }

  onSearchPromoImage(product) {
    this.setState({
      searchShouldShow: true,
      searchTitle: 'Search promo components images',
      searchingForPromo: product,
      searchLabel: 'PromoComponent',
      searchFormat: 'PromoComponent_Standard_632x395',
    });
  }

  onPromoSearch() {
    this.setState({
      searchShouldShow: true,
      searchTitle: 'Search hero image',
      searchingForPromo: null,
      searchLabel: 'HeroRegularMedium',
      searchFormat: 'HeroRegularMedium_1536x772',
    });
  }

  async handleSearchPerformed(qry) {
    let isDomain = this.getIsDomain();

    var apiUrl = 'https://' + isDomain + '/api/v2/images?q[idref_cont]=' + qry + '&q[label_eq]=' + this.state.searchLabel + '&q[format_eq]=' + this.state.searchFormat
   
    const fetchRes = await fetch(apiUrl);
    const res = await fetchRes.json();
    
    this.setState({ searchSuggestions: res.slice(0, 15).map(el => { el.loaded = false; return el; }), })
  }

  loadedSuggestion(idref) {
    this.setState(prevState => ({
      searchSuggestions: prevState.searchSuggestions.map(
        el => el.idref === idref ? { ...el, loaded: true } : el
      )
    }))
  }

  onSearchItemSelected(idref) {
    //find selected image among suggestion
    let idxImg = this.state.searchSuggestions.findIndex((item) => { return item.idref === idref });
    let selectedImgUrl = this.state.searchSuggestions[idxImg].url;

    let commonClean = () => {
      this.setState({
        searchSuggestions: [],
        searchTitle: '',
        searchingForPromo: null,
        searchShouldShow: false,
        searchLabel: '',
        searchFormat: '',
      })
    }

    //which search was performed?
    switch (this.state.searchLabel) {
      case 'PromoComponent':
        //find promo among products and associate image to product    
        this.setState(prevState => ({
          products: prevState.products.map(
            el => el.pk === this.state.searchingForPromo.pk ? { ...el, imgUrl: selectedImgUrl, isErrorImg: false, } : el
          ),
        }), commonClean());
        break;//promocomponent
      case 'HeroRegularMedium':
        this.setState({ heroImageUrl: selectedImgUrl }, commonClean());
        break;
      //useless
      default:
        break;
    }
  }

  resetSuggestions() {
    this.setState({ searchSuggestions: [] });
  }

  onEditProduct(productpk) {
    this.setState(prevState => ({
      products: prevState.products.map(
        el => el.pk === productpk ? { ...el, isEditing: true, } : { ...el, isEditing: false, }
      )
    }))
  }

  switchIs() {
    let currIs = this.state.isIsEnabled;
    this.setState({ isIsEnabled: !currIs });
  }

  render() {
    return (
      <div style={{ width: '100%' }} >
        <MenuItem
          isEnabled={!this.state.sharingContent}
          title={this.state.projectTitle}
          viewMobile={this.state.viewMobile}
          missingImages={this.state.missingImages}
          fileGenerated={this.state.fileGenerated}
          fileGeneratedName={this.state.fileGeneratedName}
          fileGeneratedForHybris={this.state.fileGeneratedForHybris}
          fileGeneratedNameForHybris={this.state.fileGeneratedNameForHybris}
          onSwitchViewClick={() => this.handleSwitchViewClick()}
          onFullDownloadClick={() => this.handleFullDownloadClick()}
          onDownloadForHybrisClick={() => this.handleDownloadForHybrisClick()}
          onHandleselectedFile={(e) => this.handleselectedFile(e)}
          onMissingImagesViewClick={(e) => this.handleMissingImagesViewClick(e)}
          onCopyClick={() => this.handleCopy()}
          onProductDeleted={(sc) => this.handleDeleteProduct(sc)}
          onProductAdded={(sc) => this.handleAddProductClick(null, sc)}
          onShare={() => this.handleShareClick()}
          onEditClick={() => this.handleEditClick()}
          onSelectClick={(action) => this.handleSelection(action)}
          onTemplateClick={() => this.handleTemplateClick()}
          onTitleChanged={(title) => this.handleTitleChange(title)}
          onPreview={() => this.handlePreview()}
          onDeleteSelectedClick={() => this.handleDeleteSelectedProduct()}
          onPromoSearch={() => this.onPromoSearch()}
          onSwitchIs={() => this.switchIs()}
          isProd={this.state.isIsEnabled}
        />

        <MessageBannerItem messages={this.state.messages} onCloseMessage={(messagePk) => { this.handleCloseMessage(messagePk); }} />

        <Spinner animation="border" style={{ position: 'absolute', left: '50%', top: '50%', 'display': (this.state.isSpinnig ? 'block' : 'none') }} />
        <GridItem
          editable={!this.state.sharingContent}
          viewMobile={this.state.viewMobile}
          missingImages={this.state.missingImages}
          products={this.state.products}
          heroImageUrl={this.state.heroImageUrl}
          onProductClick={(product) => { this.handleProductClick(product) }}
          onHandleDragOver={(e, p) => this.handleDragOver(e, p)}
          onHandleDrop={(e, p) => this.handleDrop(e, p)}
          onAddPromoClick={(p) => this.handleAddPromoClickClick(p)}
          onAddProductClick={(p, s) => this.handleAddProductClick(p, s)}
          onDeleteProductClick={(stylecode) => this.handleDeleteProduct(stylecode)}
          onHideProductClick={(product) => this.handleHideProduct(product)}
          onSearchPromoImage={(product) => this.onSearchPromoImage(product)}
          onEditProduct={(productpk) => this.onEditProduct(productpk)} />

        <ShareLinkItem onClose={() => this.handleCloseShare()} onShare={(obj) => this.handleShareSubmit(obj)} shouldShow={this.state.showShare} />
        <SearchItem onLoadedSuggestion={(idref) => { this.loadedSuggestion(idref) }}
          onItemSelected={(idref) => this.onSearchItemSelected(idref)} suggestions={this.state.searchSuggestions} onSearchPerfomed={(qry) => this.handleSearchPerformed(qry)} searchTitle={this.state.searchTitle} shouldShow={this.state.searchShouldShow} onCloseSearch={() => { this.setState({ searchShouldShow: false }) }} />
      </div>
    );
  }

}

export default App;
